<template>
  <b-modal
    id="modal-confirm-delete"
    hide-footer
    centered
    :noCloseOnBackdrop="isBusy"
    :noCloseOnEsc="isBusy"
    :hideHeaderClose="isBusy"
  >
    <div class="col-12 d-flex flex-column align-items-center modalsTables">
      <img
        class="centerImg1"
        src="@/assets/images/icons/alert-line.svg"
        width="20%"
      />
      <h3 class="pt-3 font-weight-bold mb-4">
        ¡Eliminación de documento {{ item?.original_name }}!
      </h3>
      <b-alert show variant="warning" class="alert-warning-message">
        <div class="d-flex">
          <div class="mr-3">
            <img
              src="@/assets/images/icons/alert-line.svg"
              alt=""
              width="28px"
              height="28px"
            />
          </div>
          <p style="font-size: 14px; color: #263238; margin-bottom: 0">
            Está a punto de eliminar el documento seleccionado, tenga en cuenta
            que esta acción NO se puede deshacer. Si desea continuar por favor
            seleccione la razón de liminación.
          </p>
        </div>
      </b-alert>

      <div class="row w-100 mt-5">
        <b-col cols="12" class="mb-5">
          <Select
            label="Razón de eliminación de documento"
            name="reaso"
            v-model="formData.reason"
            :options="reasons"
            :value="formData.reason"
            :required="true"
            :disabled="isBusy"
            @onSelect="onSelectDanger"
          />
        </b-col>
      </div>
      <div
        class="w-100 mt-4 d-flex align-content-center justify-content-center"
      >
        <button
          class="button_danger_modal mr-5"
          @click.prevent="deleteItem()"
          :disabled="isBusy || formData.reason === null"
        >
          <span class="cta">Eliminar</span>
          <b-spinner v-if="isBusy" />
        </button>
        <button
          class="button-secundary"
          @click="$bvModal.hide('modal-confirm-delete')"
          :disabled="isBusy"
          style="margin: 0; padding: 8px 16px; border-radius: 8px"
        >
          <span class="cta">Cancelar</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import processSevices from "@/services/legal/service.js";
import useInputs from "@/components/general/Inputs";
const { Select } = useInputs();
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  components: {
    Select,
  },
  data() {
    return {
      isBusy: false,
      reasons: [
        {
          id: 'Error de carga',
          name: 'Error de carga'
        },
        {
          id: 'Duplicidad de información',
          name: 'Duplicidad de información'
        },
        {
          id: 'Documento desactualizado',
          name: 'Documento desactualizado'
        }
      ],
      formData: {
        reason: null,
      }
    };
  },
  methods: {
    onSelectDanger(value) {
      const me = this;
      me.formData.reason = value;
    },
    async deleteItem() {
      const me = this;
      me.isBusy = true;
      try {
        await processSevices.deleteFile(me.item?.id, { reason: me.formData.reason?.id });
        me.$bvModal.hide('modal-confirm-delete');
        me.$emit('onSuccess', 'Documento eliminado con éxito');
      } catch (error) {
        me.$emit("onError", "Error al eliminar el documento");
      } finally {
        me.isBusy = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
